<template>
	<a-config-provider :locale="locale" :auto-insert-space-in-button="false">
		<nuxt/>
	</a-config-provider>
</template>

<script>
	import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

	export default {
		data() {
			return {
				locales: {zh_CN}
			}
		},
		computed: {
			locale() {
				return this.locales[this.$store.state.locale]
			}
		}
	}
</script>